import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getServiceCategories,
  createServiceCategory,
  updateServiceCategory,
  deleteServiceCategory,
} from "../../store/serviceCategory/serviceCategory.action";
import Table from "../../extra/Table";
import { warning } from "../../../util/Alert";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button as MuiButton,
  FormControlLabel,
  Switch,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const ServiceCategory = (props) => {
  const dispatch = useDispatch();
  const { serviceCategories } = useSelector((s) => s.serviceCategory);

  const [editOpen, setEditOpen] = useState(false);
  const [editing, setEditing] = useState(null); // null = creating

  const [name, setName] = useState("");
  const [icon, setIcon] = useState("");
  const [sortOrder, setSortOrder] = useState(0);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    dispatch(getServiceCategories());
  }, [dispatch]);

  const openCreate = () => {
    setEditing(null);
    setName("");
    setIcon("");
    setSortOrder(serviceCategories.length);
    setIsActive(true);
    setEditOpen(true);
  };

  const openEdit = (row) => {
    setEditing(row);
    setName(row.name || "");
    setIcon(row.icon || "");
    setSortOrder(row.sortOrder || 0);
    setIsActive(!!row.isActive);
    setEditOpen(true);
  };

  const submit = () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    const payload = { name: trimmed, icon: icon || null, sortOrder: Number(sortOrder) || 0, isActive };
    if (editing) {
      dispatch(updateServiceCategory(editing._id, payload));
    } else {
      dispatch(createServiceCategory(payload));
    }
    setEditOpen(false);
  };

  const onDelete = (id) => {
    warning()
      .then((ok) => { if (ok) dispatch(deleteServiceCategory(id)); })
      .catch(() => {});
  };

  const mapData = [
    { Header: "Sort", Cell: ({ row }) => <span className="text-white">{row.sortOrder ?? 0}</span> },
    { Header: "Name", Cell: ({ row }) => <span className="text-white fw-normal">{row.name}</span> },
    { Header: "Icon", Cell: ({ row }) => <span className="text-white">{row.icon || "—"}</span> },
    {
      Header: "Active",
      Cell: ({ row }) => (
        <span style={{ color: row.isActive ? "#16a34a" : "#dc2626", fontWeight: 600 }}>
          {row.isActive ? "Yes" : "No"}
        </span>
      ),
    },
    {
      Header: "Edit",
      Cell: ({ row }) => (
        <button
          onClick={() => openEdit(row)}
          style={{ padding: "6px 10px", backgroundColor: "transparent", border: "none", color: "#F0C420", cursor: "pointer" }}
        >
          <EditOutlinedIcon />
        </button>
      ),
    },
    {
      Header: "Delete",
      Cell: ({ row }) => (
        <button
          onClick={() => onDelete(row._id)}
          style={{ padding: "6px 10px", backgroundColor: "transparent", border: "none", color: "#dc3545", cursor: "pointer" }}
        >
          <DeleteOutlineIcon />
        </button>
      ),
    },
  ];

  return (
    <>
      <Dialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editing ? "Edit category" : "New category"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Name"
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            fullWidth
            label="Icon (optional — URL or icon key)"
            margin="normal"
            value={icon}
            onChange={(e) => setIcon(e.target.value)}
          />
          <TextField
            fullWidth
            type="number"
            label="Sort order"
            margin="normal"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
          />
          <FormControlLabel
            control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
            label="Active"
          />
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => setEditOpen(false)}>Cancel</MuiButton>
          <MuiButton onClick={submit} disabled={!name.trim()} variant="contained">
            {editing ? "Save" : "Create"}
          </MuiButton>
        </DialogActions>
      </Dialog>

      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Service Categories</span>
            <button
              onClick={openCreate}
              style={{
                padding: "8px 14px",
                backgroundColor: "#F0C420",
                border: "none",
                borderRadius: "6px",
                color: "#000",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              + New Category
            </button>
          </div>
          <div className="sellerMain">
            <div className="tableMain mt-2">
              <Table data={serviceCategories} mapData={mapData} type={"client"} />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, {
  getServiceCategories,
  createServiceCategory,
  updateServiceCategory,
  deleteServiceCategory,
})(ServiceCategory);
